//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { date } from "quasar";
import logger from "@/utils/logger";
import { mapActions, mapState } from "vuex";
import router from "../../router";

export default {
  data() {
    return {
      pagination: {
        rowsPerPage: 15, // current rows per page being displayed
        sortBy: "id",
        descending: true,
      },
      countings: [],
      countingName: "",
      countAllWarehouses: true,
      countingDate: null,
      selectedWarehouses: [],
      countAllLocationGroups: true,
      countUncountedProducts: false,
      selectedLocationGroups: [],
      countingId: 0,
      prompt: false,
      localWarehouses: [],
      newCountingDateError: false,

      filter: "",

      dense: true,

      columns: [
        {
          name: "id",
          align: "left",
          label: "Id",
          field: "id",
          sortable: true,
        },
        {
          name: "name",
          align: "left",
          label: "Navn",
          field: "name",
          style: "width: 600px",
          sortable: true,
        },
        {
          name: "created",
          align: "left",
          label: "Opprettet",
          field: "created",
          format: (val) => date.formatDate(val, "DD-MM-YYYY"),
          sortable: true,
        },
        {
          name: "createdByName",
          align: "left",
          label: "Opprettet av",
          field: "createdByName",

          sortable: true,
        },

        {
          name: "completed",
          align: "left",
          label: "Fullført",
          field: "completed",
          format: (val) => date.formatDate(val, "DD-MM-YYYY"),
          sortable: true,
        },

        {
          name: "completedByName",
          align: "left",
          label: "Fullført av",
          field: "completedByName",

          sortable: true,
        },
      ],
    };
  },
  async mounted() {
    await this.refresh();
    this.localWarehouses = this.warehouses.filter((x) => !x.isRemoteWarehouse);
  },

  watch: {
    countUncountedProducts(newValue, oldValue) {
      if (newValue != oldValue) {
        logger.log("Hey!")
        this.countingDate = null;
      }
    },
  },

  computed: {
    ...mapState("main", ["warehouses", "locations"]),

    locationGroupNames: function() {
      if (this.selectedWarehouses.length > 0) {
        // ta bort lokasjoner som ikke finnes i valgte lager
      }

      const locationNames = this.locations.map(
        (location) => location.locationGroupName
      );
      var uniqueLocationNames = [...new Set(locationNames)];
      uniqueLocationNames = uniqueLocationNames.filter((l) => l); // remove empty

      return uniqueLocationNames;
    },
  },

  methods: {
    async refresh() {
      const res = await this.getCountings();
      this.countings = res.filter((count) => count.canceled === null);
    },

    async hideFromDate(pdate) {
      pdate.hide();
    },

    enterCheck(event) {
      if (event.key === 'Enter' && this.filter != "") {
        var stocks = this.$refs.countingsTable.computedRows;
        if(stocks.length == 1) {
          this.onRowClick(stocks[0].id);
        }
      }
    },

    onRowClick(countingId) {
      router.push({ name: "StockCounting", params: { id: countingId } });
    },

    async newCounting() { 
      // this.resetForm();
      //  this.showCounting = true;
      if(this.countingDate == null && this.countUncountedProducts) {
        this.newCountingDateError = true;
        return;
      }

      var object = {};
      if (this.countingName) {
        object["name"] = this.countingName;
      } else {
        object["name"] = "Ny telling";
      }

      if (!this.countAllWarehouses) {
        object["warehouseIds"] = this.selectedWarehouses;
      }

      if (!this.countAllLocationGroups) {
        object["locationGroups"] = this.selectedLocationGroups;
      }

      if(this.countUncountedProducts) {
        const [day, month, year] = this.countingDate.split("-");
        const validDate = new Date(`${year}-${month}-${day}`);

        object["fromDate"] = validDate;
      }

      var result = await this.postCounting(object);
      this.prompt = false;

      router.push({ name: "StockCounting", params: { id: result.id } });
    },

    ...mapActions("main", [
      "getCountings",
      "getCounting",
      "getCountingStocks",
      "getCountingStock",
      "getArticles",
      "postCounting",
    ]),
  },
};
